import React from 'react';
import Header from '@/components/header/Header';
import Footer from '@/components/footer/Footer';
import classes from './ContentPane.module.scss';

const ContentPane = ({ children, header = <Header />, footer = <Footer /> }) => (
  <>
    {header}
    <div className={classes.pageWrapper}>
      <div className={classes.contentPane}>{children}</div>
      {footer}
    </div>
  </>
);

export default ContentPane;
